var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFastWatermark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 332.95 332.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 166.48,
    cy: 166.47,
    r: 158.72,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M166.48,333C74.68,333,0,258.27,0,166.48S74.68,0,166.48,0,333,74.68,333,166.48,258.27,333,166.48,333Zm0-317.44c-83.24,0-151,67.73-151,151s67.73,151,151,151,151-67.71,151-151S249.72,15.51,166.48,15.51Z",
    fill: "#37abc8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M111.11,207.94c-7.14-.61-15.35-1.31-15.93-1.31a34.16,34.16,0,0,1-13-2.54,32,32,0,0,1-9.13-5.65,18.32,18.32,0,0,0-1.27,12.17c5.36,21.87,23.26,28.71,39.28,29.88Z",
    fill: "#546e7a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M227.89,198.25c-17.1,27.34-47.38,53.07-79.63,53.07a58.39,58.39,0,0,1,0-116.78h31.85c4.88,0,10.62-5.3,10.62-10.62C268.58,122.61,249.12,161.09,227.89,198.25Z",
    fill: "#cfd8dc"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M206.65,102.69C177.33,88,123.56,92.06,123.06,92a13.27,13.27,0,1,1,2.63-26.4c2.27.22,55.8-2.06,89.55,22.57,12.65,9.23,9.21,11.24,5.93,17.8C218.85,110.62,208.56,103.65,206.65,102.69Z",
    fill: "#78909c"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M275.66,139.85c0,17.59-35.5,15.93-53.08,15.93a31.85,31.85,0,0,1,0-63.7C240.16,92.08,275.66,108,275.66,139.85Z",
    fill: "#78909c"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M204.28,97.89C166.76,80.1,115.75,86.5,113.49,86.56a13.27,13.27,0,1,0,.54,26.53c.48,0,47.75-9.32,79-1A31.82,31.82,0,0,1,204.28,97.89Z",
    fill: "#b0bec5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M238.5,240.7V178.53c-3.13,6.46-6.84,13.11-10.61,19.72a137.15,137.15,0,0,1-15.61,20.34l5,27.45s0,10.59,10.62,10.59h21.23v-5.31S249.12,240.7,238.5,240.7Z",
    fill: "#90a4ae"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M174.8,206.2c0,45.12-53.08,34.5-69,34.5V206.2a34.5,34.5,0,1,1,69,0Z",
    fill: "#90a4ae"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M185.42,240.7H105.8v15.93H196v-5.31A10.63,10.63,0,0,0,185.42,240.7Z",
    fill: "#90a4ae"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M254.43,123.93H241.57C231,123.93,227.89,108,227.89,108h13C251.52,108,254.43,123.93,254.43,123.93Z",
    fill: "#455a64"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 241.16,
    cy: 115.96,
    r: 7.96
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFastWatermark);
export default __webpack_public_path__ + "static/media/fast-watermark.7939c065f879335ab0e0c1a5a50e217f.svg";
export { ForwardRef as ReactComponent };